import React from 'react'

export default function NoScript() {
  return (
    <>
      {/* <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${process.env.REACT_APP_META_PIXEL_ID}&ev=PageView&noscript=1`}
          alt="Facebook Pixel noscript"
        />
      </noscript>

      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
          title="Google Tag Manager noscript"
        />
      </noscript> */}
    </>
  )
}
